import { Widget } from "@foretagsplatsen/widgetjs";

/**
 * btn-group implementation this switches state.
 *
 * @param {object[]} states - Array of literal objects. Each item must have a
 *   `label` key
 * @example
 * let group = buttonGroupWidget({
 *     states: [
 *         {
 *             label: 'option 1',
 *             value: 1
 *         },
 *         {
 *             label: 'option 2',
 *             value: 2
 *         }
 *     ]
 * });
 * group.stateChanged.on((item) => {
 *     console.log(`You selected ${item.value}`)
 * });
 */
export default class ButtonGroupWidget extends Widget {
	constructor({ states }) {
		super(...arguments);

		this._states = states;
		this.stateChanged = this._events.createEvent();
	}

	setStates(states) {
		this._states = states;
		this.update();
	}

	activate(state) {
		// eslint-disable-next-line no-shadow -- bad practice, we should fix this
		this._states.forEach((state) => {
			state.active = false;
		});

		state.active = true;
		this.stateChanged.trigger(state);
		this.update();
	}

	setStateByValue(value) {
		this._states.forEach((state) => {
			state.active = state.value === value;
		});

		this.update();
	}

	getActiveState() {
		return this._states.find((state) => state.active);
	}

	renderContentOn(html) {
		html.div(
			{ klass: "btn-group ButtonGroupWidget" },
			this._states.map((state) => this._stateRenderer(state)),
		);
	}

	_stateRenderer(state) {
		return (html) =>
			html
				.button(
					{
						klass: [
							"btn",
							"btn-default",
							{ active: state.active },
							{ disabled: state.active },
						],
					},
					state.label,
				)
				.click(this.activate.bind(this, state));
	}
}
